import { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import ViewListIcon from '@mui/icons-material/ViewList';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Group from '@mui/icons-material/Group';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SubmissionsHub from '../pages/SubmissionsHub';
import { CompanyProfile } from '../pages/CompanyProfile/CompanyProfile';
import Receipt from '../pages/CreditApp/Receipt';
import AppError from '../pages/CreditApp/AppError';
import PQTView from '../pages/PaymentQuoteTool/PQT.js';
import PrequalApp from '../pages/Prequal/PrequalApp';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { RequestQuote } from '@mui/icons-material';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import SendIcon from '@mui/icons-material/Send';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import PrequalReceipt from '../pages/Prequal/PrequalReceipt';
import ChatPage from '../pages/ChatPage';
import { UserManagementPage } from 'modules/userManagement';
import { default as UserProfileComponent } from '../pages/UserProfile';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BarChartIcon from '@mui/icons-material/BarChart';
import ConsolidatedTasks from '../pages/ConsolidatedTasks';
import PageLeadList from '../pages/LeadSheet/LeadsList';
import DnsIcon from '@mui/icons-material/Dns';
import LenderAdmin from '../pages/LenderAdmin';
import LenderDetails from '../pages/LenderAdmin/LenderDetails';
import LeadDetails from '../pages/LeadSheet/LeadDetails';
import CreditAppv2 from '../pages/CreditApp/CreditApp';
import ChatIcon from '@mui/icons-material/Chat';
import ProposalDetails from '../pages/Proposals/ProposalDetails';
import { PrescreenModuleContainer as LenderWaterfall } from '../pages/LenderWaterfall/PrescreenModuleContainer';
import PageCreditPrograms from '../pages/CreditPrograms/CreditPrograms';
import CreditProductDetails from '../pages/CreditPrograms/CreditProduct';
import WebsiteIntegration from '../pages/WebsiteIntegration';
import WebIcon from '@mui/icons-material/Web';
import TuneIcon from '@mui/icons-material/Tune';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import DocList from '../pages/DocMgmt/DocList';
import PostAddIcon from '@mui/icons-material/PostAdd';
import AccountDetails from '../pages/VendorOpportunity/DetailPages/AccountDetails';
import OwnerDetails from '../pages/VendorOpportunity/DetailPages/OwnerDetails';
import DealerList from '../pages/PartnerAdmin/DealerList';
import AddDealer from '../pages/PartnerAdmin/AddDealer';
import PartnerDealerAccountDetails from '../pages/PartnerAdmin/PartnerDealerDetail';
import LocationList from 'pages/LocationMgmt/LocationList';
import LocationDetail from 'pages/LocationMgmt/LocationDetail';
import AppsIcon from '@mui/icons-material/Apps';
import ShowChart from '@mui/icons-material/ShowChart';
import { LocalAtmRounded } from '@mui/icons-material';
import { Constructor } from 'pages/DynamicOCA/Constructor';
import PortalConfigurationWizard from 'pages/PortalConfigurationWizard/PortalConfigurationWizard';
import PortalSetup from 'pages/PortalSetup/PortalSetup';
import FinanceProgramMgmt from 'pages/FinanceProgramMgmt';
import { ListInventoryPage } from 'pages/InventoryMgmt';
import { OptionDetailPage } from 'pages/InventoryMgmt';
import { EquipmentDetailsPage } from 'pages/equipment/details/EquipmentDetailsPage';
import ReportsPageLender from 'pages/LenderPortal/ReportsPageLender';
import { PageOpportunityDetailsContainer } from '../pages/VendorOpportunity/DetailPages';
import { AftermarketAddEditMenuTemplatePage } from 'modules/aftermarketMenuConstructor';
import { Account, RouteConfig } from 'types';
import { AppPages, PortalConfigurationType, UserProfile, VendorProfile } from '@trnsact/trnsact-shared-types';
import { CommonDataContext } from 'contexts/CommonDataContext';
import { useSelector } from 'react-redux';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import CreditSubmissionsList from 'pages/LenderPortal/CreditSubmissionsList';
import { CreditSubmissionDetailsPageV2 } from 'pages/details/CreditSubmissionDetailsPageV2';
import AddDealers from 'pages/LenderPortal/AddDealers';
import DealerDetails from 'pages/LenderPortal/DealerMgmt/DealerDetails';
import LenderConsolidatedTasks from 'pages/LenderPortal/LenderConsolidatedTasks';
import { default as LenderProposalDetails } from 'pages/LenderPortal/LenderProposalDetails';
import { useRoutesVisibilityChecks } from './useRoutesVisibilityChecks';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import {
  AftermarketPartnerProposalsPage,
  ReportsPage as PartnerReportPage,
  DealerDetailsPage as AftermarketPartnerDealerDetailsPage,
  DealerManagementPage as AftermarketPartnerDealerManagement,
} from '../modules/aftermarket/partner';
import { EquipmentPage } from '../pages/equipment/EquipmentPage';
import DocumentViewer from 'pages/DocumentViewer';
import { StartDealPage } from '../pages/startDeal/StartDealPage';
import { Template, CloseReasonConfiguration, Departments, AuditLog } from '../pages/BPF';
import { SendCreditApplicationPage } from 'modules/sendCreditApplication';
import { LenderPortalSetup } from '../pages/PortalSetup/lender/LenderPortalSetup';
import { DealerManagementPage as LenderDealerManagement } from 'modules/lenderDealerManagement';
import { BroadcastEditorPage } from 'modules/broadcasts';
import { ExternalDashboards } from '../pages/DealerDashboards/ExternalDashboards';
import { ExternalDashboardsManagement } from '../pages/DealerDashboards/ExternalDashboardsManagement';
import { OpportunitiesListPage } from 'modules/vendorOpportunity';
import { FinanceListPage, FinanceProposalsRedirectPage } from 'modules/finance';
import { CustomerDetailsPage, CustomersListPage } from 'modules/customers';
import { ProposalsPage } from 'modules/proposals';
import { DealerReportsPage } from 'modules/reports';
import { AftermarketPage, AftermarketProductPage } from '../pages/Aftermarket';
import { AssistantLogPage } from '../pages/AssistantLog/AssistantLogPage';
import { LenderApplicationReviewPage } from 'pages/LenderApplicationReview';
import HistoryIcon from '@mui/icons-material/History';
import { ACCOUNT_DYNAMIC_IDS } from '../constants';
import { CalendarPage } from '../pages/Calendar';
import { CalendarIcon } from '@mui/x-date-pickers';

export function useRoutes() {
  const location = useLocation();
  const { pathname, search } = location;

  const { isDealerUser, isLenderUser, isCommonPartner, isAftermarketPartner, isSuperAdminOrSingleAccount } =
    useContext(CommonDataContext);

  const {
    checkIfOpportunitiesVisible,
    checkIfProposalsHubVisible,
    checkIfSubmissionsHubIsVisible,
    checkIfCustomersVisible,
    checkIfFinanceVisible,
    checkIfTasksVisible,
    routeAvailabilityChecker,
  } = useRoutesVisibilityChecks();

  const userProfile = useSelector((state: any) => state.userProfile) as UserProfile;
  const account = useSelector((state: any) => state.account) as Account;
  const vendorProfile = useSelector((state: any) => state.vp) as VendorProfile;
  const portalConfigurationData = useSelector((state: any) => portalConfigurationsSelectors.configData(state));
  const isUserHaveAccessToInvoiceAndEquipmentV2 = useSelector(
    portalConfigurationsSelectors.checkIfUserHaveAccessToInvoiceAndEquipmentV2
  );

  const appRoutes: RouteConfig[] = [
    {
      id: 'documentViewer',
      showInSidebarNav: false,
      exact: true,
      path: '/document/:id/:backRef?',
      name: 'Document Viewer',
      icon: DocumentScannerIcon,
      component: DocumentViewer,
      isVisible: () => true, // This route is not visible in the sidebar
    },
    {
      exact: true,
      icon: ShowChart,
      name: 'Dashboard',
      showInSidebarNav: true,
      id: 'externalDashboard',
      path: '/dashboard',
      component: ExternalDashboards,
      isVisible: routeAvailabilityChecker[AppPages.Dashboard],
    },
    {
      exact: true,
      showInSidebarNav: false,
      name: 'Dashboard Admin Management',
      id: 'externalDashboardManagement',
      path: '/externalDashboard/management',
      component: ExternalDashboardsManagement,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'vo',
      showInSidebarNav: true,
      exact: true,
      path: '/vo',
      name: 'Opportunities',
      icon: ViewListIcon,
      component: OpportunitiesListPage,
      isVisible: () => {
        if (isCommonPartner && !isAftermarketPartner) return true;

        return checkIfOpportunitiesVisible(isAftermarketPartner, isDealerUser, isLenderUser, vendorProfile);
      },
    },
    {
      id: 'finance',
      showInSidebarNav: true,
      exact: true,
      path: '/finance',
      name: 'Finance',
      icon: LocalAtmRounded,
      component: FinanceListPage,
      isVisible: () => checkIfFinanceVisible(),
    },
    /*     {
      id: 'voOld',
      showInSidebarNav: true,
      exact: true,
      path: '/vo-old',
      name: 'Opportunities',
      icon: ViewListIcon,
      component: PageList,
      isVisible: () => {
        if (isCommonPartner && !isAftermarketPartner) return true;

        return checkIfOpportunitiesVisible(isAftermarketPartner, isDealerUser, isLenderUser, vendorProfile);
      },
      isLegacyFeature: true,
    }, */
    {
      id: 'reporting',
      showInSidebarNav: true,
      exact: true,
      path: '/reporting',
      isNewFeature: false,
      name: 'Reporting',
      icon: BarChartIcon,
      component: PartnerReportPage,
      isVisible: () => isAftermarketPartner,
    },
    {
      id: 'proposals-hub',
      showInSidebarNav: isLenderUser,
      exact: true,
      path: '/proposals-hub',
      name: 'Proposals',
      icon: InsertDriveFileOutlinedIcon,
      component: isLenderUser ? ProposalsPage : FinanceProposalsRedirectPage,
      isVisible: () => {
        if (isLenderUser) {
          return checkIfProposalsHubVisible(
            isCommonPartner,
            isAftermarketPartner,
            isDealerUser,
            isLenderUser,
            vendorProfile
          );
        }

        return true;
      },
    },
    {
      id: 'aftermarketPartnerProposals',
      showInSidebarNav: true,
      exact: true,
      path: '/proposals',
      name: 'Proposals',
      icon: InsertDriveFileOutlinedIcon,
      component: AftermarketPartnerProposalsPage,
      isVisible: () => isAftermarketPartner,
    },
    {
      id: 'voId',
      showInSidebarNav: false,
      exact: false,
      path: '/vo/:id',
      name: 'Opportunity Detail',
      type: 'OpportunityDetail',
      icon: ViewListIcon,
      component: PageOpportunityDetailsContainer,
      supportsAnchor: true,
      fastTrackOption: true,
      isVisible: () => {
        if (isCommonPartner && !isAftermarketPartner) {
          return true;
        }
        return checkIfOpportunitiesVisible(isAftermarketPartner, isDealerUser, isLenderUser, vendorProfile);
      },
    },
    {
      id: 'submissionsList',
      showInSidebarNav: true,
      exact: true,
      path: '/cs',
      name: 'Submissions List',
      icon: ViewListIcon,
      component: CreditSubmissionsList,
      isVisible: () => isLenderUser,
    },
    {
      id: 'delearMgmtLender',
      showInSidebarNav: true,
      exact: true,
      path: '/dealers',
      name: 'Dealer Management',
      icon: DynamicFeedIcon,
      component: LenderDealerManagement,
      isVisible: () => isLenderUser,
    },
    {
      id: 'createBroadcast',
      showInSidebarNav: false,
      exact: true,
      path: '/dealers/broadcast/new',
      name: 'Broadcast',
      component: BroadcastEditorPage,
      isVisible: () => isLenderUser || isAftermarketPartner,
    },
    {
      id: 'editBroadcast',
      showInSidebarNav: false,
      exact: false,
      path: '/dealers/broadcast/:broadcastId',
      name: 'Broadcast',
      component: BroadcastEditorPage,
      isVisible: () => isLenderUser || isAftermarketPartner,
    },
    {
      id: 'AftermarketPartnerDealerManagement',
      showInSidebarNav: true,
      exact: true,
      path: '/dealer-management',
      name: 'Dealer Management',
      icon: DynamicFeedIcon,
      component: AftermarketPartnerDealerManagement,
      isVisible: () => isAftermarketPartner,
    },
    {
      id: 'submissionsHub',
      showInSidebarNav: true,
      exact: true,
      path: '/submissions',
      name: 'Submissions Hub',
      icon: DeviceHubIcon,
      component: SubmissionsHub,
      isVisible: () => {
        return (
          !isAftermarketPartner &&
          checkIfSubmissionsHubIsVisible(isDealerUser, isSuperAdminOrSingleAccount, vendorProfile)
        );
      },
    },
    {
      id: 'customers',
      showInSidebarNav: true,
      exact: true,
      path: '/customers',
      name: 'Customers',
      icon: Group,
      component: CustomersListPage,
      isVisible: () => checkIfCustomersVisible(isDealerUser),
    },
    {
      id: 'customerDetails',
      showInSidebarNav: false,
      exact: false,
      path: '/customers/:id',
      name: 'Customer Details',
      component: CustomerDetailsPage,
      isVisible: () => checkIfCustomersVisible(isDealerUser),
    },
    {
      id: 'creditapp',
      showInSidebarNav: true,
      exact: true,
      path: '/creditapp',
      name: 'Create Application',
      component: CreditAppv2,
      isVisible: () => isDealerUser && !!vendorProfile?.showPortalCreditApp,
    },
    {
      id: 'receipt',
      showInSidebarNav: false,
      exact: true,
      path: '/receipt',
      name: 'Success',
      icon: NoteAddIcon,
      component: Receipt,
      isVisible: () => isDealerUser,
    },
    {
      id: 'appError',
      showInSidebarNav: false,
      exact: true,
      path: '/app-error',
      name: 'Error',
      icon: NoteAddIcon,
      component: AppError,
      isVisible: () => isDealerUser,
    },
    {
      id: 'prequalReceipt',
      showInSidebarNav: false,
      exact: true,
      path: '/prequal-receipt',
      name: 'Success',
      icon: NoteAddIcon,
      component: PrequalReceipt,
      isVisible: () => isDealerUser,
    },
    {
      id: 'startDeal',
      showInSidebarNav: true,
      exact: true,
      path: '/startDeal',
      name: 'Start Deal',
      icon: RequestQuote,
      component: StartDealPage,
      isVisible: routeAvailabilityChecker[AppPages.StartDeal],
    },
    {
      id: 'pqtOld',
      showInSidebarNav: false,
      exact: true,
      path: '/pqtold',
      name: 'Payment Quote Tool',
      icon: MonetizationOnIcon,
      component: PQTView,
      isVisible: () => !isCommonPartner && isDealerUser,
    },
    {
      id: 'sendoca',
      showInSidebarNav: true,
      exact: true,
      path: '/sendoca',
      name: 'Send Application',
      icon: SendIcon,
      component: SendCreditApplicationPage,
      isVisible: routeAvailabilityChecker[AppPages.SendApplication],
    },
    {
      id: 'prequal',
      showInSidebarNav: true,
      exact: true,
      path: '/prequal',
      name: 'Prequal App',
      icon: NoteAddIcon,
      component: PrequalApp,
      isVisible: () => isDealerUser && !!vendorProfile?.showPrequal,
    },
    {
      id: 'chat',
      showInSidebarNav: true,
      exact: true,
      path: '/chat',
      name: 'Conversations',
      icon: ChatIcon,
      component: ChatPage,
      isVisible: () => isDealerUser && vendorProfile?.showChat === 'show',
    },
    {
      id: 'leads',
      showInSidebarNav: true,
      exact: true,
      path: '/leads',
      name: 'Leads',
      icon: DnsIcon,
      component: PageLeadList,
      isVisible: routeAvailabilityChecker[AppPages.Leads],
    },
    {
      id: 'lenderTasks',
      showInSidebarNav: true,
      exact: true,
      name: 'Tasks',
      path: '/tasks',
      icon: FormatListNumberedIcon,
      component: LenderConsolidatedTasks,
      isVisible: () => isLenderUser,
    },
    {
      id: 'reports',
      showInSidebarNav: true,
      exact: true,
      path: '/reports',
      name: 'Reports',
      icon: BarChartIcon,
      component: isDealerUser ? DealerReportsPage : ReportsPageLender,
      isVisible: routeAvailabilityChecker[AppPages.Reports],
    },
    {
      id: 'calendar',
      showInSidebarNav: true,
      exact: true,
      path: '/calendar',
      name: 'Calendar',
      icon: CalendarIcon,
      component: CalendarPage,
      isVisible: () => true,
    },
    {
      id: 'consolidatedTasks',
      showInSidebarNav: true,
      exact: true,
      path: '/consolidatedTasks',
      name: 'Tasks',
      icon: FormatListNumberedIcon,
      component: ConsolidatedTasks,
      isVisible: () => checkIfTasksVisible(),
    },
    {
      id: 'leadDetailLeadId',
      showInSidebarNav: false,
      exact: false,
      path: '/leadDetail/:leadId',
      name: 'Lead Detail',
      icon: ViewListIcon,
      component: LeadDetails,
      isVisible: () => (isLenderUser ? !!vendorProfile : true),
    },
    {
      id: 'proposalDetailPropId',
      showInSidebarNav: false,
      exact: false,
      path: '/proposalDetail/:propId',
      name: 'Proposal Detail',
      icon: ViewListIcon,
      component: isDealerUser || isAftermarketPartner ? ProposalDetails : LenderProposalDetails,
      isVisible: () => isDealerUser || isLenderUser || isAftermarketPartner,
    },
    {
      id: 'creditProgramDetailCreditProdId',
      showInSidebarNav: false,
      exact: false,
      path: '/creditProgramDetail/:creditProdId',
      name: 'Credit Product Detail',
      icon: ViewListIcon,
      component: CreditProductDetails,
      isVisible: () => isDealerUser,
    },
    {
      id: 'templates',
      showInSidebarNav: true,
      exact: true,
      path: '/templates',
      name: 'Docs',
      icon: PostAddIcon,
      component: DocList,
      isVisible: routeAvailabilityChecker[AppPages.Docs],
    },
    {
      id: 'accountDetailsAccountId',
      showInSidebarNav: false,
      exact: false,
      path: '/accountDetails/:accountId',
      name: 'Account Details',
      icon: ViewListIcon,
      component: AccountDetails,
      isVisible: () => isDealerUser || isLenderUser,
    },
    {
      id: 'ownerPgDetailsOwnerPgId',
      showInSidebarNav: false,
      exact: false,
      path: '/ownerPgDetails/:ownerPgId',
      name: 'Owner/PG Details',
      icon: ViewListIcon,
      component: OwnerDetails,
      isVisible: () => isDealerUser || isLenderUser,
    },
    {
      id: 'dealerMgmt',
      showInSidebarNav: true,
      exact: true,
      path: '/dealerMgmt',
      name: 'Dealer Management',
      icon: ViewListIcon,
      component: DealerList,
      isVisible: () => isCommonPartner && !isAftermarketPartner,
    },
    {
      id: 'addDealer',
      showInSidebarNav: true,
      exact: true,
      path: '/addDealer',
      name: 'Add Dealer',
      icon: ViewListIcon,
      component: AddDealer,
      isVisible: () => isCommonPartner && !isAftermarketPartner,
    },
    {
      id: 'partnerAccountDetailsDynamicsId',
      showInSidebarNav: false,
      exact: false,
      path: '/partnerAccountDetails/:dynamicsId',
      name: 'Partner Dealer Account Details',
      icon: ViewListIcon,
      component: PartnerDealerAccountDetails,
      isVisible: () => isDealerUser,
    },
    {
      id: 'submissionDetails',
      showInSidebarNav: false,
      exact: false,
      path: '/cs/:id',
      name: 'Submission Details',
      icon: ViewListIcon,
      component: CreditSubmissionDetailsPageV2,
      supportsAnchor: true,
      isVisible: () => isLenderUser,
    },
    {
      id: 'addDealers',
      showInSidebarNav: true,
      exact: true,
      path: '/add',
      name: 'Add Dealers',
      icon: NoteAddIcon,
      component: AddDealers,
      isVisible: () => isLenderUser && !vendorProfile,
    },
    {
      id: 'dealerDetailsForLender',
      showInSidebarNav: false,
      exact: false,
      path: '/dealers/:dealerId',
      type: 'DealerDetails',
      name: 'Dealer Details',
      icon: DynamicFeedIcon,
      component: DealerDetails,
      isVisible: () => isLenderUser,
    },
    {
      id: 'dealerDetailsForAftermarketPartner',
      showInSidebarNav: false,
      exact: false,
      path: '/partner-dealers/:partnerLinkId',
      type: 'DealerDetails',
      name: 'Dealer Details',
      icon: DynamicFeedIcon,
      component: AftermarketPartnerDealerDetailsPage,
      isVisible: () => isAftermarketPartner,
    },
  ];

  const userRoutes: RouteConfig[] = [
    {
      id: 'userProfile',
      showInSidebarNav: true,
      exact: false,
      path: '/profile/:dynamicsContactId',
      dynamicPath: `/profile/${userProfile.dynamicsContactId}`,
      name: 'User Profile',
      icon: PersonIcon,
      component: UserProfileComponent,
      isVisible: () => isDealerUser || isLenderUser || isAftermarketPartner,
    },
    {
      id: 'companyProfile',
      showInSidebarNav: true,
      exact: true,
      path: '/company-profile',
      name: 'Company Profile',
      icon: BusinessIcon,
      component: CompanyProfile,
      isVisible: routeAvailabilityChecker[AppPages.CompanyProfile],
    },
    {
      id: 'acctAdmin',
      showInSidebarNav: true,
      exact: true,
      path: '/acctadmin',
      name: 'User Management',
      icon: SupervisorAccountIcon,
      component: UserManagementPage,
      isVisible: routeAvailabilityChecker[AppPages.UserManagement],
    },
    {
      id: 'creditPrograms',
      showInSidebarNav: false,
      exact: true,
      path: '/creditPrograms',
      name: 'Credit Programs',
      icon: DnsIcon,
      component: PageCreditPrograms,
      isVisible: () => isDealerUser,
    },
    {
      id: 'lenderAdmin',
      showInSidebarNav: true,
      exact: true,
      path: '/lenderadmin',
      name: 'Lender Management',
      icon: PersonAddIcon,
      component: LenderAdmin,
      isVisible: routeAvailabilityChecker[AppPages.LenderManagement],
    },
    {
      id: 'lender',
      showInSidebarNav: false,
      exact: false,
      path: '/lenderadmin/:dynamicLenderProfileId',
      type: 'LenderDetail',
      name: 'Lender Details',
      icon: PersonAddIcon,
      component: LenderDetails,
      isVisible: routeAvailabilityChecker[AppPages.LenderManagement],
    },
    {
      id: 'financePrograms',
      showInSidebarNav: true,
      exact: true,
      path: '/finance-programs',
      name: 'Finance Programs',
      icon: LocalAtmRounded,
      component: FinanceProgramMgmt,
      isVisible: routeAvailabilityChecker[AppPages.FinancePrograms],
    },
    {
      id: 'locationMgmt',
      showInSidebarNav: true,
      exact: true,
      path: '/locationMgmt',
      name: 'Location Management',
      icon: ViewListIcon,
      component: LocationList,
      isVisible: routeAvailabilityChecker[AppPages.LocationManagement],
    },
    {
      id: 'pcw',
      showInSidebarNav: false,
      exact: true,
      path: '/pcw',
      name: 'Portal Configuration Wizard',
      icon: TuneIcon,
      component: PortalConfigurationWizard,
      isVisible: () => {
        if (isLenderUser) {
          return !!vendorProfile;
        }
        return isDealerUser || isAftermarketPartner;
      },
    },
    {
      id: 'portalSetup',
      showInSidebarNav: true,
      exact: true,
      path: '/portal-setup',
      name: 'Portal Setup',
      icon: TuneIcon,
      component: PortalSetup,
      isVisible: routeAvailabilityChecker[AppPages.PortalSetup],
    },
    {
      id: 'aftermarket',
      showInSidebarNav: true,
      exact: true,
      path: '/aftermarket',
      name: 'Aftermarket Products',
      icon: StorefrontIcon,
      component: AftermarketPage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'aftermarketSubMenues-List',
      showInSidebarNav: false,
      exact: true,
      path: '/aftermarket/menu',
      name: 'Aftermarket Menu',
      icon: StorefrontIcon,
      component: AftermarketPage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'aftermarketSubMenues-Dashboard',
      showInSidebarNav: false,
      exact: true,
      path: '/aftermarket/dashboard',
      name: 'Aftermarket Dashboard',
      icon: StorefrontIcon,
      component: AftermarketPage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'aftermarketMenuNEdit',
      showInSidebarNav: false,
      exact: false,
      path: '/aftermarket/menu/edit/:proposalMenuId',
      name: 'Menu Details',
      component: AftermarketAddEditMenuTemplatePage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'aftermarketMenuNew',
      showInSidebarNav: false,
      exact: true,
      path: '/aftermarket/menu/new',
      name: 'Menu Details',
      component: AftermarketAddEditMenuTemplatePage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'aftermarketAdd',
      showInSidebarNav: false,
      exact: true,
      path: '/aftermarket/add',
      name: 'Add Aftermarket Product',
      icon: StorefrontIcon,
      component: AftermarketProductPage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'aftermarketEdit',
      showInSidebarNav: false,
      exact: true,
      path: '/aftermarket/edit/:aftermarketProductId',
      name: 'Edit Aftermarket Product',
      icon: StorefrontIcon,
      component: AftermarketProductPage,
      isVisible: routeAvailabilityChecker[AppPages.AftermarketProducts],
    },
    {
      id: 'inventory',
      showInSidebarNav: true,
      exact: true,
      path: '/inventory',
      name: 'Inventory',
      icon: LocalShippingIcon,
      component: ListInventoryPage,
      isVisible: routeAvailabilityChecker[AppPages.Inventory],
    },
    {
      id: 'inventoryOptionCreate',
      showInSidebarNav: false,
      exact: true,
      path: '/inventory/options/new',
      name: 'New Option',
      icon: LocalShippingIcon,
      component: OptionDetailPage,
      isVisible: routeAvailabilityChecker[AppPages.Inventory],
    },
    {
      id: 'inventoryOptionDetail',
      showInSidebarNav: false,
      exact: true,
      path: '/inventory/options/:optionId',
      name: 'Option Details',
      icon: LocalShippingIcon,
      component: OptionDetailPage,
      isVisible: routeAvailabilityChecker[AppPages.Inventory],
    },
    {
      id: 'locationDetailLocationId',
      showInSidebarNav: false,
      exact: false,
      path: '/locationDetail/:locationId',
      name: 'Location Details',
      icon: ViewListIcon,
      component: LocationDetail,
      isVisible: routeAvailabilityChecker[AppPages.LocationManagement],
    },
    {
      id: 'websiteIntegration',
      showInSidebarNav: true,
      exact: true,
      path: '/website-integration',
      name: 'Website Integration',
      icon: WebIcon,
      component: WebsiteIntegration,
      isVisible: routeAvailabilityChecker[AppPages.WebsiteIntegrations],
    },
    {
      id: 'constructor',
      showInSidebarNav: false,
      exact: true,
      path: '/constructor',
      name: 'OCA Constructor',
      icon: AppsIcon,
      component: Constructor,
      isVisible: () => true,
    },
    {
      id: 'lenderWaterfall',
      showInSidebarNav: true,
      exact: true,
      path: '/lender-waterfall',
      name: 'Prescreen Tools',
      icon: ViewListIcon,
      component: LenderWaterfall,
      isVisible: routeAvailabilityChecker[AppPages.PrescreenTools],
    },
    {
      id: 'equipmentDetailsPage',
      showInSidebarNav: false,
      exact: true,
      path: '/equipment/:equipmentId/details',
      name: 'Equipment Details',
      component: EquipmentDetailsPage,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'equipmentCreatePage',
      showInSidebarNav: false,
      exact: true,
      path: '/equipment/:VOId/:dynamicVOId',
      name: 'Equipment',
      component: EquipmentPage,
      isVisible: () => isUserHaveAccessToInvoiceAndEquipmentV2,
    },
    {
      id: 'equipmentCreatePage',
      showInSidebarNav: false,
      exact: true,
      path: '/equipment/new',
      name: 'Equipment',
      component: EquipmentPage,
      isVisible: () => isUserHaveAccessToInvoiceAndEquipmentV2,
    },
    {
      id: 'equipmentUpdatePage',
      showInSidebarNav: false,
      exact: true,
      path: '/equipment/:VOId/:dynamicVOId/:equipmentId',
      name: 'Equipment',
      component: EquipmentPage,
      isVisible: () => isUserHaveAccessToInvoiceAndEquipmentV2,
    },
    {
      id: 'inventoryUpdatePage',
      showInSidebarNav: false,
      exact: true,
      path: '/equipment/:equipmentId',
      name: 'Equipment',
      component: EquipmentPage,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'bpfCreatePage',
      showInSidebarNav: false,
      exact: true,
      path: '/bpf/template',
      name: 'Template',
      component: Template,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'bpfUpdatePage',
      showInSidebarNav: false,
      exact: false,
      path: '/bpf/template/:id',
      name: 'Template',
      component: Template,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'bpfCloseReasonConfigurationPage',
      showInSidebarNav: false,
      exact: false,
      path: '/bpf/closeReasonConfiguration/:id',
      name: 'Closed Reasons',
      component: CloseReasonConfiguration,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'bpfDepartmentsPage',
      showInSidebarNav: false,
      exact: false,
      path: '/bpf/departments',
      name: 'Departments',
      component: Departments,
      isVisible: () => isSuperAdminOrSingleAccount,
    },
    {
      id: 'bpfAuditLogPage',
      showInSidebarNav: false,
      exact: false,
      path: '/bpf/auditLog',
      name: 'AuditLog',
      component: AuditLog,
      isVisible: () => true,
    },
    {
      id: 'assistantLog',
      showInSidebarNav: true,
      exact: true,
      path: '/assistant-log',
      name: 'Assistant Log',
      icon: HistoryIcon,
      component: AssistantLogPage,
      isVisible: () => account.magicEmailAddress,
    },
    {
      id: 'lenderApplicationReview',
      showInSidebarNav: false,
      exact: true,
      path: '/lender-review/:activityId',
      name: 'Review Extracted Terms',
      component: LenderApplicationReviewPage,
      isVisible: () => true, // This route is not visible in the sidebar
    },
    {
      exact: false,
      icon: TuneIcon,
      name: 'Portal Setup',
      id: 'lenderPortalSetup',
      showInSidebarNav: true,
      component: LenderPortalSetup,
      path: '/lender/PortalSetup',
      isVisible: () => {
        if (isSuperAdminOrSingleAccount && isLenderUser && vendorProfile) return true;

        const portalSetting =
          portalConfigurationData?.[PortalConfigurationType.LenderFeatureFlags]?.jsonDefinition?.config
            ?.enableEnhancedBusinessProcessFlows;

        return portalSetting && isLenderUser && vendorProfile;
      },
    },
  ];

  const allRoutes = [...appRoutes, ...userRoutes];

  const getActiveRouteConfig = () => {
    const currentUrl = pathname + search;
    return allRoutes.find(routeConfig => {
      return routeConfig.exact
        ? currentUrl === routeConfig.path
        : currentUrl.includes(routeConfig.path!.slice(0, routeConfig.path!.indexOf(':')));
    });
  };

  const [currentRouteConfig, setCurrentRouteConfig] = useState<RouteConfig>(getActiveRouteConfig() as RouteConfig);

  const { availableAppRoutes, availalbeUserRoutes } = useMemo(
    () => ({
      availableAppRoutes: appRoutes.filter(r => (r.isVisible ? r.isVisible() : true)),
      availalbeUserRoutes: userRoutes.filter(r => (r.isVisible ? r.isVisible() : true)),
    }),
    [portalConfigurationData, isDealerUser, isLenderUser, isCommonPartner, isAftermarketPartner, vendorProfile]
  );

  useEffect(() => {
    setCurrentRouteConfig(getActiveRouteConfig() as RouteConfig);
  }, [location]);

  return {
    currentRouteConfig,
    availableAppRoutes,
    availalbeUserRoutes,
    allRoutes,
  };
}
